/**
 * Очищает markdown текст от обертки ```markdown ... ``` и других кодовых блоков
 */
export const cleanMarkdownText = (text: string | null): string => {
  if (!text) return "";

  let cleanedText = text.trim();

  // Удаляем обертку ```markdown и закрывающие ```
  const markdownPattern = /^```markdown\s*([\s\S]*?)```\s*$/;
  let match = cleanedText.match(markdownPattern);
  if (match && match[1]) {
    cleanedText = match[1].trim();
  }

  // Удаляем обертку ``` и закрывающие ``` (для случаев без указания языка)
  const codeBlockPattern = /^```\s*([\s\S]*?)```\s*$/;
  match = cleanedText.match(codeBlockPattern);
  if (match && match[1]) {
    cleanedText = match[1].trim();
  }

  // Удаляем начальные строки типа "```markdown" если они остались
  cleanedText = cleanedText.replace(/^```markdown\s*\n/, "");
  cleanedText = cleanedText.replace(/^```\s*\n/, "");

  // Удаляем закрывающие ``` в конце если они остались
  cleanedText = cleanedText.replace(/\n\s*```\s*$/, "");

  return cleanedText.trim();
};
